import OfflineDataScreen from "@/components/OfflineDataScreen";

export default function Data() {
    return (
        <OfflineDataScreen />
    );
}
